import { FieldPath } from "react-hook-form";
type SearchOptionLabelsType = {
    [key in FieldPath<SearchFormInputs>]: { [key: string]: string } | true;
};

export const SearchOptionsLabels: Partial<SearchOptionLabelsType> = {
    focus: {
        beach: "Beach",
        city: "City",
        nature: "Nature",
        0: "No preference"
    },
    suitability: {
        0: "It does not matter",
        couples: "Couples",
        groupOfFriends: "Group of friends",
        solo: "Solo",
        smallChildren: "Small children",
        schoolAgeChildren: "School age children",
        young: "Young people",
        midAge: "Middle-aged people",
        seniors: "Seniors",
        partySeekers: "Party seekers",
        honeymooners: "Honeymooners"
    },
    continent: {
        0: "Anywhere",
        africa: "Africa",
        asia: "Asia",
        europe: "Europe",
        "north-america": "North America",
        australia: "Australia and Oceania",
        "south-america": "South America",
        "middle-east": "Middle East",
        "central-america": "Central America and the Caribbean"
    },
    month: {
        0: "Anytime",
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December",
        spring: "Spring",
        summer: "Summer",
        autumn: "Autumn",
        winter: "Winter"
    },
    "weather.rainseason": {
        1: "Avoid rain season",
        2: "Just in dry season"
    },
    "other.citySize": {
        1: "I prefer smaller places",
        2: "I prefer larger cities"
    },
    "other.boat": {
        1: "Avoid boat transport"
    },
    "other.island": {
        1: "Prefer islands",
        2: "Avoid islands"
    },
    distance: {
        1: "I am willing to travel a bit",
        2: "I don't want to travel"
    },
    "other.season": {
        1: "I prefer travelling off season",
        2: "I prefer travelling in high season"
    },
    "other.airportDistance": {
        1: "I am willing to travel a bit",
        2: "I don't want to travel"
    },
    "other.vaccinationRequirements": {
        1: "Not too strict requirements",
        2: "No vaccination required"
    },
    "other.visa": {
        1: "Not too strict requirements",
        2: "No visa required"
    },
    "other.visaOrigin": {
        eu: "European Union",
        usa: "United States"
    },
    "prices.flightOrigin": {
        europe: "Europe",
        canada: "Canada",
        asia: "Asia",
        easternUs: "Eastern US",
        centralUs: "Central US",
        westernUs: "Western US"
    },
    "other.englishKnowledge": {
        1: "Basic English knowledge of locals",
        2: "Good English knowledge of locals"
    }
};

export const SearchOptionsLabelsForChips: Partial<SearchOptionLabelsType> = {
    "other.citySize": {
        1: "Small",
        2: "Large"
    },
    "other.island": {
        1: "Yes",
        2: "No"
    },
    "other.season": {
        1: "Low",
        2: "High"
    },
    focus: true,
    suitability: true,
    continent: true,
    month: true
};
